import { Box, useDisclosure } from "@chakra-ui/react"
import AugmentationLayout, {
  AugmentationLayoutProps
} from "@pathwright/ux/src/components/augmentation/AugmentationLayout"
import AugmentationRoutedPanel from "@pathwright/ux/src/components/augmentation/AugmentationRoutedPanel"
import {
  AugmentationToolbarOption,
  useAugmentationToolbar
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { useCanViewSimpleNav } from "../view-permission/useUnifiedHomePermissions"
import HomeAugmentationPopover from "./HomeAugmentationPopover"
import { useHomeAugmentationToolbarOptions } from "./useHomeAugmentationToolbar"

const HomeAugmentationPopoverLayoutInner = ({
  Primary
}: {
  Primary?: AugmentationLayoutProps["components"]["Primary"]
}) => {
  const { me } = usePathwrightContext()
  const options = useHomeAugmentationToolbarOptions()

  // Remove the add path option since we're not in Home context.
  options.splice(options.length - 1, 1)

  const homeOption: AugmentationToolbarOption = {
    key: "home",
    tLabel: "Home",
    icon: "avatar",
    renderIcon: (icon) => <UserAvatar user={me} size="2xs" />,
    to: "/home"
  }

  // Prepend home option to first group.
  const firstGroup = options[0]
  if (Array.isArray(firstGroup)) {
    firstGroup?.unshift(homeOption)
  }

  const signOutOption: AugmentationToolbarOption = {
    key: "sign-out",
    tLabel: "nav.navbar_user.sign_out",
    icon: "arrow-up-line",
    renderIcon: (icon) => <Box transform="rotate(-90deg)">{icon}</Box>,
    to: "/auth/sign-out"
  }

  // Append sign out option to last group.
  const lastGroup = options.slice(-1)[0]
  if (Array.isArray(lastGroup)) {
    lastGroup?.push(signOutOption)
  }

  const toolbar = useAugmentationToolbar(options)
  const disclosure = useDisclosure()

  return (
    <AugmentationLayout
      components={{
        Primary,
        Panel: AugmentationRoutedPanel,
        Toolbar: HomeAugmentationPopover
      }}
      toolbar={toolbar}
      disclosure={disclosure}
      spacing={[10, 10]}
      allowOverlay
      panelPosition="far"
      align="right"
    />
  )
}

const HomeAugmentationPopoverLayout = ({
  Primary
}: {
  Primary?: AugmentationLayoutProps["components"]["Primary"]
}) => {
  return useCanViewSimpleNav() ? (
    <HomeAugmentationPopoverLayoutInner Primary={Primary} />
  ) : null
}

export default HomeAugmentationPopoverLayout
